module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qdige4-b9721404595767b55d8557179aee6594.jpg";